// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {

  color: orange;

}

.pie {

  position: relative;
  margin-top: 20px;
  bottom: 10px;
  /* margin-top: calc(100%-15px); */
  /* margin-bottom: 15px; */
  /* bottom: 10px; */

  text-align: center;

}

.empresa {

  color: orange;
  font-size: 18px;

}

.contenedor {

  height: 100vh;
  width: 100%;
  behavior: smooth;
  
}

/*@GOOGLE*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}

.btn-google {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.md-24 {

  font-size: 24px;

}

.md-25 {

  font-size: 24px;

}

.md-36 {

  font-size: 36px;

}

.md-48 {

  font-size: 48px;

}

/*@GOOGLE*/
`, "",{"version":3,"sources":["webpack://./src/app/slider/main/main.component.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;;AAEf;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;;EAElB,kBAAkB;;AAEpB;;AAEA;;EAEE,aAAa;EACb,eAAe;;AAEjB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,gBAAgB;;AAElB;;AAEA,UAAU;AACV;EACE,eAAe;EACf;;;;;AAKF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA,UAAU","sourcesContent":["a {\r\n\r\n  color: orange;\r\n\r\n}\r\n\r\n.pie {\r\n\r\n  position: relative;\r\n  margin-top: 20px;\r\n  bottom: 10px;\r\n  /* margin-top: calc(100%-15px); */\r\n  /* margin-bottom: 15px; */\r\n  /* bottom: 10px; */\r\n\r\n  text-align: center;\r\n\r\n}\r\n\r\n.empresa {\r\n\r\n  color: orange;\r\n  font-size: 18px;\r\n\r\n}\r\n\r\n.contenedor {\r\n\r\n  height: 100vh;\r\n  width: 100%;\r\n  behavior: smooth;\r\n  \r\n}\r\n\r\n/*@GOOGLE*/\r\n.material-symbols-outlined {\r\n  cursor: pointer;\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 400,\r\n  'GRAD' 0,\r\n  'opsz' 24\r\n}\r\n\r\n.btn-google {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.md-24 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-25 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-36 {\r\n\r\n  font-size: 36px;\r\n\r\n}\r\n\r\n.md-48 {\r\n\r\n  font-size: 48px;\r\n\r\n}\r\n\r\n/*@GOOGLE*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
